/* eslint-disable pec/import-graphql-hooks-from-local */

import {
  OperationVariables,
  QueryHookOptions as OptionsType,
  QueryResult,
  useQuery as useApolloQuery,
} from '@apollo/client'
import { useErrorHandler } from 'components/error'
import { DocumentNode } from 'graphql'
import { useEffect } from 'react'

// Override useQuery from @apollo/client to use custom defaults

export function useQuery<TData = any, TVariables = OperationVariables>(
  query: DocumentNode,
  options: OptionsType<TData, TVariables> = {}
): QueryResult<TData, TVariables> {
  const handleError = useErrorHandler()

  const queryReturn = useApolloQuery<TData, TVariables>(query, {
    fetchPolicy: 'network-only',
    ...options,
  })

  useEffect(() => {
    if (queryReturn.error) {
      handleError(queryReturn.error)
    }
  }, [queryReturn.error, handleError])

  return {
    ...queryReturn,
    data: queryReturn.data || ({} as any),
  }
}

export type QueryHookOptions<TData = any, TVariables = OperationVariables> = OptionsType<TData, TVariables>
